import { motion } from "framer-motion";
import { Puzzle } from "lucide-react";

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -84, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Reveal = ({ children, delay = 0, className = "", y = 34 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label, light = false }) => (
  <div className="flex items-center gap-3 mb-5" data-testid={`chapter-${num}`}>
    <span className={`font-mono text-xs tracking-[0.25em] ${light ? "text-amber-300" : "text-terracotta"}`}>
      ({num})
    </span>
    <span className={`h-px w-12 ${light ? "bg-amber-300/50" : "bg-terracotta/40"}`} />
    <span className={`font-mono text-xs tracking-[0.25em] uppercase ${light ? "text-amber-200" : "text-amber-800"}`}>
      {label}
    </span>
  </div>
);

export const PuzzleBadge = ({ className = "" }) => (
  <div className={`flex h-11 w-11 items-center justify-center rounded-xl bg-terracotta text-amber-50 shadow-lg shadow-terracotta/25 ${className}`}>
    <Puzzle className="h-6 w-6" strokeWidth={1.8} />
  </div>
);

export const IMAGES = {
  hero: "https://images.pexels.com/photos/8541885/pexels-photo-8541885.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  about: "https://images.pexels.com/photos/7869446/pexels-photo-7869446.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  arts: "https://images.pexels.com/photos/8422146/pexels-photo-8422146.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  meals: "https://images.pexels.com/photos/8617558/pexels-photo-8617558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  group: "https://images.pexels.com/photos/8466774/pexels-photo-8466774.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  play: "https://images.unsplash.com/photo-1761208663763-c4d30657c910?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjaGlsZHJlbiUyMGxlYXJuaW5nJTIwZGF5Y2FyZSUyMGNsYXNzcm9vbSUyMGFydHMlMjBjcmFmdHMlMjBwbGF5fGVufDB8fHx8MTc4NzUyMDQwN3ww&ixlib=rb-4.1.0&q=85",
};
